var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcSignupMove = function SvgIcSignupMove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none",
    viewBox: "0 0 33 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1067CD",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.292,
    d: "M4.826 9.943H1.95c-.72 0-1.305.584-1.305 1.305v1.945c0 .72.584 1.305 1.305 1.305h2.875c.72 0 1.305-.585 1.305-1.305v-1.945c0-.72-.584-1.305-1.305-1.305"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD770",
    d: "M27.826 23.575a2.48 2.48 0 0 1-1.77-.73L22.412 19.2a.96.96 0 0 1 0-1.37l2.1-2.106a.98.98 0 0 1 .684-.29.96.96 0 0 1 .685.284l2.294 2.3a2.4 2.4 0 0 1 1.143-.297 2.242 2.242 0 0 1 1.57 3.83l-1.292 1.293a2.48 2.48 0 0 1-1.77.73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m25.195 16.41 2.92 2.9.239-.239a1.35 1.35 0 0 1 .963-.4c.318-.002.625.119.859.336a1.29 1.29 0 0 1 0 1.84l-.278.279-1.014 1.014a1.544 1.544 0 0 1-2.171 0l-3.644-3.644zm0-1.939c-.514 0-1.007.205-1.37.569l-2.1 2.106a1.94 1.94 0 0 0 0 2.74l3.638 3.643a3.49 3.49 0 0 0 4.916 0l1.014-.988.278-.278a3.23 3.23 0 0 0 .943-2.326 3.23 3.23 0 0 0-4.14-3.03l-1.842-1.841a1.94 1.94 0 0 0-1.37-.569z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD770",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.938,
    d: "M20.388.97a10.09 10.09 0 0 0-9.406 6.408 3.708 3.708 0 0 0 0 7.371 10.091 10.091 0 1 0 9.4-13.78z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1067CD",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.292,
    d: "M21.964 9.62a.646.646 0 1 0 0-1.292.646.646 0 0 0 0 1.292M25.842 9.62a.646.646 0 1 0 0-1.292.646.646 0 0 0 0 1.292"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#67AEFF",
    d: "M26.585 28.588a1 1 0 0 1-.827-.472l-3.192-5.278h-7.5a1 1 0 0 1-.465-.116l-1.24-.691a1 1 0 0 1-.395-.4l-3.618-7.004a1.22 1.22 0 0 0-1.085-.646H6.196a.97.97 0 0 1-.97-.969v-1.454a.97.97 0 0 1 .97-.969H8.34a4.43 4.43 0 0 1 3.935 2.423l1.48 2.868h8.262a3.275 3.275 0 0 1 3.276 3.282v1.7l3.333 5.555a.97.97 0 0 1-.33 1.292l-1.207.73a1 1 0 0 1-.504.149m-4.62-9.11v-.238h-6.46l.123.245z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.195 11.558H8.34a3.48 3.48 0 0 1 3.094 1.886l1.751 3.392h8.832a2.306 2.306 0 0 1 2.306 2.313v1.97l3.476 5.75-1.215.737-3.476-5.712h-8.036l-1.247-.684-3.618-7.003a2.18 2.18 0 0 0-1.938-1.183H6.2v-1.466zm16.72 8.877v-1.293a.9.9 0 0 0-.561-.842.9.9 0 0 0-.35-.062h-8.089l1.13 2.184h7.863zM6.195 9.62a1.94 1.94 0 0 0-1.938 1.938v1.415a1.94 1.94 0 0 0 1.938 1.938h2.067a.24.24 0 0 1 .226.136l3.618 7.003c.182.35.466.636.814.82l1.24.691c.289.156.61.238.937.24h6.92l2.907 4.812a1.94 1.94 0 0 0 2.661.66l1.215-.737a1.94 1.94 0 0 0 .646-2.662l-3.185-5.271v-1.435a4.244 4.244 0 0 0-4.244-4.25h-7.65l-1.214-2.346A5.4 5.4 0 0 0 8.34 9.62z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.491,
    cy: 5.491,
    r: 5.491,
    fill: "#F7F6EC",
    transform: "matrix(-1 0 0 1 18.303 18.413)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.938,
    d: "M12.81 25.519a1.615 1.615 0 1 0 0-3.23 1.615 1.615 0 0 0 0 3.23M26.954 30.028a2.952 2.952 0 1 0 0-5.905 2.952 2.952 0 0 0 0 5.905"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F6EC",
    d: "M26.952 28.406a1.33 1.33 0 1 0 0-2.662 1.33 1.33 0 0 0 0 2.662"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F6EC",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.938,
    d: "M12.797 17.12a6.783 6.783 0 1 0 .027 13.565 6.783 6.783 0 0 0-.027-13.565m0 12.322a5.566 5.566 0 1 1 0-11.132 5.566 5.566 0 0 1 0 11.132"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD770",
    d: "m17.288 15.047-2.086 2.087a2.907 2.907 0 0 1-4.116 0 2.903 2.903 0 0 1 0-4.11l1.415-1.414"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.938,
    d: "m17.288 15.047-2.086 2.087a2.907 2.907 0 0 1-4.116 0v0a2.903 2.903 0 0 1 0-4.11l1.415-1.414"
  })));
};
export default SvgIcSignupMove;